export default __webpack_public_path__ + "static/media/12-32-13.a363e045.jpg";